import { Any, Obj } from "@kizmann/pico-js";
import NTableCellString from "@kizmann/nano-ui/src/table/src/table-cell/types/table-cell-string.jsx";

export default Obj.assign({}, NTableCellString, {

    name: 'NTableCellLink',

    inject: {
        AppIndex: {
            default: undefined
        }
    },

    render()
    {
        if ( ! this.init ) {
            return null;
        }

        let fn = Obj.get(this.column, 'modelValue.fn');

        if ( Any.isString(fn) ) {
            fn = this.AppIndex && this.AppIndex[fn];
        }

        if ( ! Any.isFunction(fn) ) {
            return (<div>FIX FN</div>);
        }

        return (
            <div>
                <RouterLink to={fn(this.item)}>{ this.input }</RouterLink>
            </div>
        );
    }

});